import { Inject, Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root',
})

export class WebinarsOnDemandService {
  private readonly webinarsOnDemandBaseApiUrl: string;


  constructor(@Inject('BASE_URL') baseUrl: string, private dataService: DataService) {
    this.webinarsOnDemandBaseApiUrl = `${baseUrl}api/webinars-on-demand`;
  }

  public getWebinars(industry: string, search: string | null = null) {
    let webinarsOnDemandApiUrl = `${this.webinarsOnDemandBaseApiUrl}/${industry}?search=${btoa(search!)}`;

    return this.dataService.get<any>(webinarsOnDemandApiUrl);
  }
}
